import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { save, load } from 'redux-localstorage-simple'

import application from './application/reducer'
import { updateVersion } from './global/actions'
import user from './user/reducer'
import transactions from './transactions/reducer'
import swap from './swap/reducer'
import mint from './mint/reducer'
import burn from './burn/reducer'
import multicall from './multicall/reducer'

const PERSISTED_KEYS: string[] = ['user', 'transactions']

const rootReducer = combineReducers({
  application,
  user,
  transactions,
  swap,
  mint,
  burn,
  multicall
})

const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      thunk: false
    }).concat(save({ states: PERSISTED_KEYS })),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  preloadedState: load({ states: PERSISTED_KEYS }) as any
})

store.dispatch(updateVersion())

export default store

export type AppState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
